import type { OutreachClosedReason, OutreachLeadStatus, OutreachVertical } from '../../../shared/types';
import type { ScoreComponentRow, OutreachCounterKey } from './types';

export const STATUS_LABELS: Record<OutreachLeadStatus, string> = {
  new: 'new',
  reached_out: 'reached out',
  followup: 'followup',
  replied: 'replied',
  closed: 'closed',
};

export const CLOSED_REASON_LABELS: Record<OutreachClosedReason, string> = {
  won: 'won',
  not_a_fit: 'not a fit',
};

export const VERTICAL_LABELS: Record<OutreachVertical, string> = {
  healthcare: 'healthcare',
  'professional-services': 'professional services',
};

/** The four buttons in the drawer footer, in ladder order. There is no `new`
    button: it is the arrival state only, so a lead never goes back to
    untouched. */
export const STATUS_BUTTONS: OutreachLeadStatus[] = ['reached_out', 'followup', 'replied'];

/** The dossier's compliance footnote, one copy for the drawer and the sheet. */
export const COMPLIANCE_NOTE =
  "Contacts shown only where published on the business's own site. LinkedIn links are for manual viewing only.";

export const SCORE_COMPONENTS: Array<Pick<ScoreComponentRow, 'key' | 'label' | 'maximum'>> = [
  { key: 'businessFit', label: 'business fit', maximum: 40 },
  { key: 'opportunity', label: 'opportunity', maximum: 35 },
  { key: 'reachability', label: 'reachability', maximum: 25 },
];

/** Link keys in the order the drawer shows them, each with the words the
    "nothing found" line uses. */
export const LINK_FIELDS: { key: string; label: string; missing: string }[] = [
  { key: 'website', label: 'Website', missing: 'website' },
  { key: 'instagram', label: 'Instagram', missing: 'Instagram' },
  { key: 'facebook', label: 'Facebook', missing: 'Facebook' },
  { key: 'linkedinCompany', label: 'LinkedIn company', missing: 'LinkedIn company page' },
  { key: 'googleBusiness', label: 'Google profile', missing: 'Google profile' },
];

/** `short` is the one-word label the five mobile tiles use; desktop vitals
    have the room for the full one. */
export const COUNTER_TILES: {
  key: OutreachCounterKey;
  label: string;
  short?: string;
  tone?: 'gold' | 'accent' | 'ok';
}[] = [
  { key: 'new', label: 'new' },
  { key: 'reached_out', label: 'reached out', short: 'reached', tone: 'gold' },
  { key: 'followup', label: 'followup', tone: 'gold' },
  { key: 'replied', label: 'replied', tone: 'accent' },
  { key: 'closed_won', label: 'closed won', short: 'won', tone: 'ok' },
];
